import {
  LOAD_QUESTION_FEEDBACK_REQUEST,
  LOAD_QUESTION_FEEDBACK_SUCCESS,
  LOAD_QUESTION_FEEDBACK_FAILURE,
  UPDATE_QUESTION_FEEDBACK_REQUEST,
  UPDATE_QUESTION_FEEDBACK_SUCCESS,
  UPDATE_QUESTION_FEEDBACK_FAILURE,
} from './constants';
import { logError } from 'util/errors';
import services from 'api/services';
const { QuestionFeedbackService } = services;

export const loadQuestionFeedbacks = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_QUESTION_FEEDBACK_REQUEST });
    const response = await QuestionFeedbackService.getQuestionFeedbacks();
    dispatch({ type: LOAD_QUESTION_FEEDBACK_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_QUESTION_FEEDBACK_FAILURE, error: ex.message });
  }
};

export const updateQuestionFeedback = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_QUESTION_FEEDBACK_REQUEST });
    const response = await QuestionFeedbackService.updateQuestionFeedback(body);
    dispatch({ type: UPDATE_QUESTION_FEEDBACK_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_QUESTION_FEEDBACK_FAILURE, error: ex.message });
  }
};
